import React from 'react';
// eslint-disable-next-line jira/import/no-restricted-import
import { SmartCardProvider } from '@atlaskit/link-provider';
import type { ProductType } from '@atlaskit/linking-common';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import {
	useGlobalObjectPreviewPanels,
	type GlobalObjectType,
} from '@atlassian/preview-panel-global-objects';
import type { ProjectContext } from '@atlassian/jira-router-resources-project-context/src/services/project-context/types.tsx';

// TODO Move this to be a route level configuration
const SUPPORT_PANEL_TYPES: GlobalObjectType[] = [
	'jira-issue',
	'identity-team',
	'confluence-page',
	'townsquare-goal',
	'townsquare-project',
];

export const LinkingProviders = ({ children }: { children: React.ReactNode }) => {
	const { data } = useProjectContext();

	const product = getProductForSmartCardProvider(data);

	if (fg('jira-glance-panel')) {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const smartCardProviderProps = useGlobalObjectPreviewPanels({
			supportedObjects: SUPPORT_PANEL_TYPES,
		});

		return (
			<SmartCardProvider
				{...smartCardProviderProps}
				product={product}
				isAdminHubAIEnabled={data?.isAIEnabled ?? false}
			>
				{children}
			</SmartCardProvider>
		);
	}

	return (
		<SmartCardProvider product={product} isAdminHubAIEnabled={data?.isAIEnabled ?? false}>
			{children}
		</SmartCardProvider>
	);
};

const getProductForSmartCardProvider = (
	project: ProjectContext | null | undefined,
): ProductType | undefined => {
	switch (project?.projectType) {
		case 'software':
			return 'JSW';
		case 'business':
			return 'JWM';
		case 'service_desk':
			return 'JSM';
		case 'product_discovery':
			return 'JPD';
		default:
			return undefined;
	}
};
